define(function() {

	const IpsModelCollection = require('civicsBase/ipsModelCollection');
	const theModel = require('civicsModels/agencymap_model');

	return IpsModelCollection.extend({ model: theModel });
	
});